export class MessageToAuthor {

    contentId: number;
    subject: string;
    text: string;

}
